import React from "react";
import LegalDoc from "../../components/LegalDoc";

const PrivacyPolicy: React.FC = () => {
  return (
    <LegalDoc fileName="privacy-policy.txt" documentType="Privacy Policy" />
  );
};

export default PrivacyPolicy;
